<template>
  <v-list-group :value="false" active-class="primary white--text">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-icon>mdi-office-building-cog</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Cơ sở vật chất</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/categories">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Đầu mục thiết bị</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/assets">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Danh sách thiết bị & Tem QR</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/locations">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Quản lý khu vực</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/borrows">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Mượn trả trực tuyến</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/maintenance">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Bảo trì & Sửa chữa</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/inventory">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Quản lý kiểm kê</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/proposals">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Đề xuất mua sắm</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/facility/transfers">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Xuất nhập & Luân chuyển</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>

<script>
export default {
  name: 'FacilityServices'
}
</script>
